<template>
  <v-dialog :value="show" persistent max-width="480">
    <v-card>
      <v-card-title class="text-h5"> Ajout </v-card-title>
      <v-card-text>
        Indiquez l'image à ajouter au produit ainsi que son libellé.
        <v-file-input
          v-model="fichier"
          label="Image"
          accept="image/jpeg, image/png, image/gif"
          show-size
          :error-messages="fichierErrors"
          @input="$v.fichier.$touch()"
          @blur="$v.fichier.$touch()"
        ></v-file-input>
        <v-text-field
          label="Libellé"
          v-model="intitule"
          hint="Intitulé, description ou information au sujet de l'image."
          clearable
          counter="500"
          :error-messages="intituleErrors"
          @input="$v.intitule.$touch()"
          @blur="$v.intitule.$touch()"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" text @click="validate" :disabled="!valid">
          OK
        </v-btn>
        <v-btn color="error" text @click="$emit('cancel')"> Annuler </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import { maxFileSize } from "@/validators/validators";

export default {
  name: "ProduitImageDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    // editedImage: {
    //   type: Object,
    //   default: null,
    // },
  },
  data() {
    return {
      fichier: null,
      intitule: null,
    };
  },
  watch: {
    show() {
      //   if (this.editedImage != null) {
      //     this.fichier = this.editedImage.fichier;
      //     this.description = this.editedImage.description;
      //   } else {
      this.fichier = null;
      this.intitule = null;
      this.$v.$reset();
      //   }
    },
  },
  computed: {
    valid() {
      return !this.$v.$invalid;
    },
    fichierErrors() {
      const errors = [];
      if (!this.$v.fichier.$dirty) return errors;
      !this.$v.fichier.required && errors.push("Obligatoire");
      !this.$v.fichier.maxFileSize && errors.push("Taille maximale: 2Mo");
      return errors;
    },
    intituleErrors() {
      const errors = [];
      if (!this.$v.intitule.$dirty) return errors;
      !this.$v.intitule.maxLength && errors.push("500 caractères maximum");
      return errors;
    },
  },
  methods: {
    validate() {
      let filereader = new FileReader();
      filereader.onload = () => {
        let img = {
          fichier: this.fichier.name,
          intitule: this.intitule,
          //data: this.arrayBufferToBase64(filereader.result),
          mimetype: this.fichier.type,
          local: true,
          fileCtl: this.fichier,
        };

        this.$emit("ok", img);
      };
      filereader.readAsArrayBuffer(this.fichier);
    },
    arrayBufferToBase64(buffer) {
      var binary = "";
      var bytes = new Uint8Array(buffer);
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary);
    },
  },
  validations: {
    fichier: {
      required,
      maxFileSize: maxFileSize(2100000), //2Mb
    },
    intitule: {
      maxLength: maxLength(500),
    },
  },
};
</script>

<style></style>
